import { render, staticRenderFns } from "./PartnerReportDetailDeleteDialog.vue?vue&type=template&id=306163dd&scoped=true&"
import script from "./PartnerReportDetailDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportDetailDeleteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerReportDetailDeleteDialog.vue?vue&type=style&index=0&id=306163dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306163dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
